import React from 'react';
import ReactDOM from 'react-dom/client';
import liff from '@line/liff';
import App from './App';
import './index.css';

const LIFF_ID = '2009003538-O7KSgwno';

// Show initial loading screen - Minimal Clean Style (Matches APP Theme)
// This shows immediately before React loads to prevent white screen
// Initialize LIFF before rendering React
// Show error screen - Modern Neo-Mint Style
const showError = (message: string) => {
  const root = document.getElementById('root')!;
  root.innerHTML = `
    <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #020617; padding: 24px; font-family: 'Kanit', sans-serif;">
      <div style="text-align: center; max-width: 360px; background: rgba(30, 41, 59, 0.5); backdrop-filter: blur(20px); padding: 48px 32px; border-radius: 40px; border: 1px solid rgba(255, 255, 255, 0.05); box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);">
        <div style="width: 80px; height: 80px; background: rgba(244, 63, 94, 0.1); border-radius: 30px; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; border: 1px solid rgba(244, 63, 94, 0.2);">
          <span style="font-size: 32px;">⚠️</span>
        </div>
        <h2 style="color: white; font-size: 24px; font-weight: 900; margin-bottom: 8px; letter-spacing: -0.025em;">Connection Failed</h2>
        <p style="color: #94a3b8; font-size: 14px; margin-bottom: 32px; line-height: 1.6;">${message}</p>
        <button onclick="location.reload()" style="background: #3FFFB2; color: #020617; border: none; padding: 16px 32px; border-radius: 16px; font-size: 14px; font-weight: 900; cursor: pointer; text-transform: uppercase; letter-spacing: 0.1em; width: 100%; transition: all 0.3s;">Retry Connection</button>
      </div>
    </div>
  `;
};

// Show initial loading screen - Yai Cal Style
const showLoading = () => {
  const root = document.getElementById('root')!;
  root.innerHTML = `
    <div style="min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.6); backdrop-filter: blur(8px); font-family: 'Kanit', system-ui, sans-serif; position: relative;">
      
      <div style="display: flex; flex-direction: column; align-items: center; gap: 32px; animation: zoomIn 0.5s ease-out;">
        <div style="position: relative; width: 240px; height: 240px;">
          <img src="/yai_cal_loader_final.png" style="width: 100%; height: 100%; object-fit: contain; animation: bounce 2s infinite; filter: drop-shadow(0 10px 15px rgba(0,0,0,0.1));" />
        </div>
        
        <div style="text-align: center;">
          <h2 style="font-size: 28px; font-weight: 700; color: #334155; margin: 0 0 12px 0; animation: pulse 2s infinite;">รอแป๊บนึงน้า...</h2>
          <p style="color: #059669; font-size: 18px; font-weight: 500; margin: 0; opacity: 0.8;">ยัยแคลกำลังฟิตกล้ามรอ 🥑💪</p>
        </div>
      </div>

      <style>
        @keyframes bounce { 
          0%, 100% { transform: translateY(-5%); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); } 
          50% { transform: translateY(0); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); } 
        }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }
        @keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
      </style>
    </div>
  `;
};

// Initialize LIFF before rendering React
async function initializeApp() {
  showLoading(); // Show immediate loading state

  try {
    // Initialize LIFF
    await liff.init({ liffId: LIFF_ID });

    // If not logged in, redirect to login
    if (!liff.isLoggedIn()) {
      liff.login();
      return;
    }

    // Get profile and cache it
    const profile = await liff.getProfile();
    (window as any).__LIFF_PROFILE__ = profile;
    (window as any).__LIFF_READY__ = true;

    // Render React app
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error: any) {
    console.error('LIFF initialization failed:', error);

    // Check if already initialized
    if (error?.message?.includes('already')) {
      (window as any).__LIFF_READY__ = true;

      if (liff.isLoggedIn()) {
        const profile = await liff.getProfile();
        (window as any).__LIFF_PROFILE__ = profile;
      }

      ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
      return;
    }

    showError(error?.message || 'System unable to establish terminal link with LINE.');
  }
}

initializeApp();
